import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { getTestIds } from '../../utils/TestIds';
import { Badge } from '../Badge';
import { Column } from '../Layout/Column';
import { Row } from '../Layout/Row';
import { Typography } from '../Typography';
import styles from './RecordCard.module.scss';
export const SUPERSEDED_BY = '\u2192';
export const GetRecordCardRowTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const typographyPropsOf = (source)=>({
        variant: source === null || source === void 0 ? void 0 : source.variant,
        skin: source === null || source === void 0 ? void 0 : source.skin,
        weight: source === null || source === void 0 ? void 0 : source.weight,
        ellipsis: source === null || source === void 0 ? void 0 : source.ellipsis
    });
const supersededAmountOf = (struckAmount, separator, testId)=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph3",
                skin: "secondary",
                className: styles.struck,
                testId: testId,
                children: struckAmount
            }),
            separator === 'arrow' && /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph3",
                skin: "secondary",
                children: SUPERSEDED_BY
            })
        ]
    });
const withNote = (param)=>{
    let { content, note, alignItems, testId } = param;
    return note == null ? content : /*#__PURE__*/ _jsxs(Column, {
        alignItems: alignItems,
        children: [
            content,
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph3",
                skin: "secondary",
                testId: testId,
                children: note
            })
        ]
    });
};
const valueNoteClassNameOf = (valueNote)=>valueNote == null ? undefined : styles.withValueNote;
export const totalRowOf = (param)=>{
    let { id, label, amount, struckAmount, supersededSeparator = 'none', aside, asideVariant = 'paragraph3', isStruck, dividerAbove, labelVariant, labelWeight, skin, valueNote, testId } = param;
    const { RecordCardRowTestIds } = GetRecordCardRowTID(testId);
    return {
        id,
        spread: true,
        dividerAbove,
        dividerSkin: 'subtle',
        className: valueNoteClassNameOf(valueNote),
        label: {
            hideColon: true,
            text: label,
            variant: labelVariant !== null && labelVariant !== void 0 ? labelVariant : 'paragraph3',
            weight: labelWeight,
            skin
        },
        value: withNote({
            note: valueNote,
            alignItems: 'end',
            testId: RecordCardRowTestIds.ValueNote(),
            content: /*#__PURE__*/ _jsxs(Row, {
                gap: 8,
                alignItems: "baseline",
                children: [
                    struckAmount != null && supersededAmountOf(struckAmount, supersededSeparator, RecordCardRowTestIds.StruckAmount()),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        weight: "normal",
                        skin: skin,
                        className: isStruck ? styles.struck : undefined,
                        testId: RecordCardRowTestIds.Amount(),
                        children: amount
                    }),
                    aside != null && /*#__PURE__*/ _jsx(Typography, {
                        variant: asideVariant,
                        skin: "secondary",
                        testId: RecordCardRowTestIds.Aside(),
                        children: aside
                    })
                ]
            })
        })
    };
};
export const lineRowOf = (param)=>{
    let { key, id, name, amount, struckAmount, supersededSeparator = 'none', badge, badgeSkin, gap, variant, labelVariant, shrinkable, isStruck, skin, weight, labelNote, valueNote, testId } = param;
    const { RecordCardRowTestIds } = GetRecordCardRowTID(testId);
    return {
        key,
        id,
        spread: true,
        className: valueNoteClassNameOf(valueNote),
        label: {
            hideColon: true,
            shrinkable,
            variant: labelVariant,
            text: withNote({
                note: labelNote,
                testId: RecordCardRowTestIds.LabelNote(),
                content: /*#__PURE__*/ _jsxs(Row, {
                    gap: gap,
                    alignItems: "center",
                    className: shrinkable ? styles.lineDetails : undefined,
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: variant,
                            skin: skin,
                            weight: weight,
                            className: isStruck ? styles.struck : undefined,
                            testId: RecordCardRowTestIds.Name(),
                            children: name
                        }),
                        badge != null && /*#__PURE__*/ _jsx(Badge, {
                            size: "small",
                            skin: badgeSkin,
                            outlined: true,
                            rounded: true,
                            testId: RecordCardRowTestIds.Badge(),
                            children: badge
                        })
                    ]
                })
            })
        },
        value: withNote({
            note: valueNote,
            alignItems: 'end',
            testId: RecordCardRowTestIds.ValueNote(),
            content: /*#__PURE__*/ _jsxs(Row, {
                gap: 8,
                alignItems: "baseline",
                children: [
                    struckAmount != null && supersededAmountOf(struckAmount, supersededSeparator, RecordCardRowTestIds.StruckAmount()),
                    amount != null && /*#__PURE__*/ _jsx(Typography, {
                        variant: variant,
                        skin: skin,
                        weight: weight,
                        className: isStruck ? styles.struck : undefined,
                        testId: RecordCardRowTestIds.Amount(),
                        children: amount
                    })
                ]
            })
        })
    };
};
